import { Button, Card, CardContent, Label, Textarea } from '@repo/shadcn';
import { useState } from 'react';

import { useCreateSale } from '../create-sale.hook';

export const SaveDraft = () => {
    const [draftNote, setDraftNote] = useState('');
    const { cartData, draftSaveLoading, draftSaveError, handleSaveDraft } =
        useCreateSale();
    return (
        <Card className="border-none shadow-none">
            <CardContent className="p-4">
                <h3 className="mb-4 text-xl font-semibold">Draft Details</h3>
                <div className="space-y-4">
                    <div className="max-h-56 overflow-y-auto rounded-md">
                        <ul className="space-y-2 p-4">
                            {cartData?.data.items.map((cart) => (
                                <li key={cart.id} className="list-decimal">
                                    {cart.product_name} - {cart.quantity}*
                                    {cart.price}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div>
                        <Label htmlFor="draft-note">Notes</Label>
                        <Textarea
                            id="draft-note"
                            placeholder="Add any notes about your cart here..."
                            value={draftNote}
                            onChange={(e) => setDraftNote(e.target.value)}
                            rows={4}
                        />
                        <Button
                            onClick={() => handleSaveDraft(draftNote)}
                            type="button"
                            variant="secondary"
                            className="mt-4 w-full"
                        >
                            {draftSaveLoading ? 'Saving...' : 'Save as Draft'}
                        </Button>
                        {draftSaveError && (
                            <p className="mt-2 text-sm text-red-500">
                                {draftSaveError}
                            </p>
                        )}
                    </div>
                </div>
            </CardContent>
        </Card>
    );
};

SaveDraft.displayName = 'SaveDraft';
